import {IconProps, darkGray, gray, white, yellow} from './shared';

export const Great = ({selected}: IconProps) => {
  const backgroundColor = selected ? yellow : gray;
  const foregroundColor = selected ? darkGray : white;
  const backgroundOpacity = selected ? '1.0' : '0.7';

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
        fill={backgroundColor}
        opacity={backgroundOpacity}
      />
      <path
        d="M19.9984 31.5483C13.9673 31.5483 10.3827 27.6561 8.28493 24.9097C7.60895 24.0247 8.35419 22.516 9.46782 22.516H30.5291C31.6427 22.516 32.3879 24.0247 31.7119 24.9097C29.6142 27.6561 26.0296 31.5483 19.9984 31.5483Z"
        fill={foregroundColor}
      />
      <path
        d="M15.4823 12.8386C15.4823 14.6202 14.0381 16.0644 12.2565 16.0644C10.4749 16.0644 9.0307 14.6202 9.0307 12.8386C9.0307 11.057 10.4749 9.61279 12.2565 9.61279C14.0381 9.61279 15.4823 11.057 15.4823 12.8386Z"
        fill={foregroundColor}
      />
      <path
        d="M30.9662 12.8386C30.9662 14.6202 29.5219 16.0644 27.7404 16.0644C25.9588 16.0644 24.5146 14.6202 24.5146 12.8386C24.5146 11.057 25.9588 9.61279 27.7404 9.61279C29.5219 9.61279 30.9662 11.057 30.9662 12.8386Z"
        fill={foregroundColor}
      />
    </svg>
  );
};
